var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dash-content-outer col" },
    [
      _c("div", { staticClass: "head w-intro" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "actns" }, [
          _c(
            "div",
            {
              staticClass: "btn main txt-blk",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.openRowOverlay.apply(null, arguments)
                },
              },
            },
            [
              _c("span", { staticClass: "hvr" }),
              _vm._v(" "),
              _c("span", { staticClass: "ico" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "26",
                      height: "26",
                      viewBox: "0 0 26 26",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM11.5 11.5V6.5H14.5V11.5H19.5V14.5H14.5V19.5H11.5V14.5H6.5V11.5H11.5Z",
                        fill: "black",
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "txt" }, [_vm._v("Add new row")]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "transition-group",
        {
          staticClass: "inner-content hp",
          attrs: { name: "list", tag: "div" },
        },
        _vm._l(_vm.rows, function (row, rIndex) {
          return _c(
            "ContentRow",
            { key: row.id, attrs: { row: row, index: rIndex } },
            _vm._l(row.assets, function (asset, cIndex) {
              return _c("ContentCard", {
                key: asset.name + cIndex,
                attrs: {
                  title: asset.name,
                  posterSrc: asset.poster,
                  moneyTag: _vm.Global.plans[0].name,
                  genreTags: asset.tags,
                  index: cIndex,
                },
              })
            }),
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("h5", { staticClass: "txt-grt" }, [_vm._v("Homepage")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "This page represents your homepage, you can add, delete or organize rows as you wish"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }